module.exports = __webpack_public_path__ + "static/media/yarra-trams.482bbd99.svg";